module.exports = __webpack_public_path__ + "assets/sl-SI.3b231b55.png";